const SQL_UTC_TIMESTAMP = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/;

/**
 * The api returns D1 `CURRENT_TIMESTAMP` values as `YYYY-MM-DD HH:MM:SS`, which is UTC with no
 * zone marker. `new Date()` reads that as LOCAL time (and Safari rejects the space outright), so
 * normalise it to ISO UTC before it reaches a formatter. Anything else passes through untouched,
 * including a bare `YYYY-MM-DD` calendar date, which formatters already treat as a date.
 */
export function sqlUtcToIso(value: string): string {
  return SQL_UTC_TIMESTAMP.test(value) ? `${value.replace(' ', 'T')}Z` : value;
}
